import { render } from "./detail.vue?vue&type=template&id=0b75ba2a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=0b75ba2a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b75ba2a"],['__file',"src/views/people/people/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b75ba2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b75ba2a', __exports__)) {
    console.log('reload')
    api.reload('0b75ba2a', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=0b75ba2a&scoped=true", () => {
    console.log('re-render')
    api.rerender('0b75ba2a', render)
  })

}


export default __exports__